import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Eye, MousePointerClick, Filter, FormInput, MessageSquareQuote, Database, BarChart3, Video } from 'lucide-react';
export function AdvancedAnalytics() {
  return <FeaturePageLayout hero={{
    badge: 'ADVANCED ANALYTICS',
    h1: <>
            See Everything.{' '}
            <span className="text-gradient" data-id="element-1002">Guess Nothing.</span>
          </>,
    subtitle: 'Enterprise-grade analytics built directly into your website. Heatmaps, session recordings, and funnels that feed straight into your CRM.',
    stats: [{
      value: '100%',
      label: 'Visibility'
    }, {
      value: '0',
      label: 'Extra Fees'
    }, {
      value: '24/7',
      label: 'Tracking'
    }]
  }} problem={{
    subtitle: 'You are flying blind.',
    cards: [{
      icon: <Eye size={24} data-id="element-1003" />,
      title: 'The Traffic Black Hole',
      desc: 'You know how many people visited, but you have no idea what they actually did or why they left.'
    }, {
      icon: <BarChart3 size={24} data-id="element-1004" />,
      title: 'Tool Fatigue',
      desc: 'Paying $99/mo for heatmaps, $49/mo for surveys, and trying to stitch the data together yourself.'
    }, {
      icon: <Database size={24} data-id="element-1005" />,
      title: 'Disconnected Data',
      desc: "Your website analytics and your CRM don't talk. Sales reps reach out blind with no behavioral context."
    }]
  }} howItWorks={{
    steps: [{
      title: 'MR Tracks',
      desc: 'Every click, scroll, and form interaction is silently recorded in the background.'
    }, {
      title: 'MR Analyzes',
      desc: 'Data is compiled into visual heatmaps, funnels, and session recordings.'
    }, {
      title: 'MR Syncs',
      desc: "Behavioral data is pushed directly to the prospect's CRM record automatically."
    }]
  }} features={{
    cards: [{
      icon: <Filter size={24} data-id="element-1006" />,
      title: 'Smart Funnels',
      desc: 'Track every step of your conversion funnel. See exactly where visitors drop off and why.'
    }, {
      icon: <Video size={24} data-id="element-1007" />,
      title: 'Session Recordings',
      desc: 'Watch real visitor sessions like a movie. See exactly how they navigate your site.'
    }, {
      icon: <MousePointerClick size={24} data-id="element-1008" />,
      title: 'Heatmaps',
      desc: 'Click maps, scroll maps, and movement maps show you exactly where users engage most.'
    }, {
      icon: <FormInput size={24} data-id="element-1009" />,
      title: 'Form Analytics',
      desc: 'Discover which specific form fields cause friction and abandonment.'
    }, {
      icon: <MessageSquareQuote size={24} data-id="element-1010" />,
      title: 'Microsurveys',
      desc: 'Trigger quick on-site polls to capture visitor feedback exactly when it matters.'
    }, {
      icon: <Database size={24} data-id="element-1011" />,
      title: 'CRM Enrichment',
      desc: 'All behavioral data feeds directly into your CRM. MR knows a lead is hot before they even call.'
    }]
  }} integrations={{
    tools: ['Salesforce', 'HubSpot', '1Dash.Pro', 'GoHighLevel']
  }} pricingCallout="Enterprise analytics included free in MR Pro. Stop paying for Hotjar or FullStory." demoCallout="Watch a live session recording of a visitor navigating the site." data-id="element-1001" />;
}